import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodewarsComponent } from './simple-icons-codewars.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodewarsComponent ],
    exports:      [ SimpleIconsCodewarsComponent ],
    bootstrap:    []
})
export class SimpleIconsCodewarsModule {}
